import { displayToast, sendAppsignalError } from "../modules/utils";
import CarouselInitializer from "../components/carousel";

class DistributorShop {
  constructor(node) {
    this.element = node;

    this.shopWrapper = this.element.querySelector(".js-create-distributor-shop-wrapper");
    this.totalCostElement = document.querySelector(".js-create-distributor-shop-total-cost");
    this.totalQvElement = document.querySelector(".js-create-distributor-shop-total-qv");

    this.qvComponent = document.querySelector("[data-js-class='qv']");

    this.url = new URL(this.element.dataset.url, window.location.origin);

    this.initialize();
  }

  initialize() {
    window.addEventListener("cart-updated", (e) => {
      this.totalCostElement.innerHTML = e.detail.shoppingTotals;
      this.totalQvElement.innerHTML = e.detail.qvTotals;

      this.qvComponent.dispatchEvent(new CustomEvent("qv-update"));
    });

    window.addEventListener("update-prices", () => {
      this.updateShop();
    });
  }

  updateShop() {
    this.shopWrapper.classList.add("is-loading");

    fetch(this.url, {
      retries: 3,
      retryDelay: 1000,
      headers: {
        Accept: "application/json",
      },
    })
      .then(async (response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json().catch(() => null);
        }

        throw new Error("Error loading new product prices");
      })
      .then((response) => {
        if (response === null) {
          return;
        }

        this.shopWrapper.innerHTML = response.html;

        window.Beyuna.initClasses(this.shopWrapper);
        new CarouselInitializer(this.shopWrapper);
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "DistributorShop", {
          response: this.response,
        });
      })
      .finally(() => {
        this.shopWrapper.classList.remove("is-loading");
      });
  }
}

const distributorShop = document.querySelector("[data-js='create-distributor-shop']");

if (distributorShop) {
  new DistributorShop(distributorShop);
}
